import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css, cx } from '@emotion/css'
import {
  IconAdd,
  theme
} from '@contrast-security-inc/design-system-foundations'
import { Button } from '@contrast-security-inc/design-system-buttons'

const minWidth = '1200px'

export function WizardDialogButton({
  disabled = false,
  ...props
}: {
  readonly disabled?: boolean
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <FormattedMessage
      id="action_header_addAgent"
      children={(msg) => {
        return (
          <a data-e2e="add-agent-button" {...props}>
            <Button
              Icon={IconAdd}
              data-e2e="add-agent-inner-button"
              className={cx(
                css`
                  ${disabled && 'cursor: not-allowed'};
                  height: 34px;
                  margin-top: 8px;
                  width: 34px;
                  padding: 0;
                  align-items: center;
                  @media (min-width: ${minWidth}) {
                    & {
                      width: auto;
                      padding: 5px 10px;
                    }
                  }

                  background: ${theme.color.brandEmeraldGreen};
                  &:hover:enabled,
                  &:focus-visible:enabled {
                    background: ${theme.color.brandEmeraldGreen};
                    color: ${theme.color.black};
                    filter: brightness(0.9);

                    svg {
                      fill: ${theme.color.black};
                    }
                  }
                `
              )}
            >
              <span
                className={css`
                  display: none;
                  @media (min-width: ${minWidth}) {
                    & {
                      display: block;
                    }
                  }
                `}
              >
                {msg}
              </span>
            </Button>
          </a>
        )
      }}
    />
  )
}
